export default "__VITE_ASSET__Dlh2ipS3__"